import React from "react";
import styles from "./Divider.module.scss";
import classNames from "classnames";

export interface DividerProps {
  or?: boolean;
}

export const Divider: React.FC<DividerProps> = ({ or }) => (
  <div className={classNames(styles.base, { [styles.or]: or })}>
    {or ? <span className={styles.text}>OR</span> : null}
  </div>
);
